window.addEventListener('click', (event) => {
  const target = event.target;
  if (target.classList.contains("share") || target.parentNode.classList.contains("share")) {

    if (target.classList.contains("share")) {
      target.classList.toggle("--active")
    } else {
      target.parentNode.classList.toggle("--active")
    }
  } else {
    if (!target.classList.contains("share-button")) {
      const shares = document.querySelectorAll(".share")
      shares.forEach(share => {
        if (share.classList.contains("--active")) {
          share.classList.remove("--active")
        }
      });
    }
  }
});

